import { MouseEvent } from 'react';
import { NotificationPanelFilterButton } from './notification-panel-filter-button';
import { NotificationPanelFilterOptionWrap } from './notification-panel-filter-option-wrap';

interface NotificationPanelFilterOptionButtonProps {
  title: string;
  additionClasses?: string;
  onClick?: (e: MouseEvent) => void;
}
export function NotificationPanelFilterOptionButton(props: NotificationPanelFilterOptionButtonProps) {
  const { title, additionClasses, onClick } = props;
  return (
    <NotificationPanelFilterOptionWrap onClick={onClick}>
      <NotificationPanelFilterButton title={title} additionClasses={additionClasses} />
    </NotificationPanelFilterOptionWrap>
  );
}
